module.exports = {
    // basic
    'delete-all-access': 'eliminar todos los accesos',
    'well-flags': 'etiquetas de pozo',
    'well-name': 'nombre del pozo',
    'my-well-groups': 'mis grupos de pozos',
    'well-group': 'grupo de pozos',
    'a-well-group': 'un grupo de pozos',
    'a-user': 'un usuario',
    'well-group-name': 'nombre del grupos de pozos',
    'hole-direction': 'direccion del agujero',
    'hole-directions': 'direcciones del agujero',
    'pad-name': 'nombre del patín',
    'pad-number': 'número de patín',
    'source-well': 'pozo fuente',
    'new-well-data': 'datos de nuevos pozos',
    'pending-approvals': 'aprobaciones pendientes',
    'maintenance-invoice-settings': 'configuración de la factura de mantenimiento',
    'historical': 'histórico',
    'disabled': 'desactivado',
    'well-aliases': 'alias de pozo',
    // raw
    'search-by-api': 'Buscar por API',
    'spud-date-required': 'Ingrese una fecha de spud válida.',
    'api-invalid': `La API debe tener 10 o 14 dígitos, sin guiones.`,
    'rig-no-company-message': 'Por favor, seleccione una empresa.',
    //well header template
    'copy-from-default-title': 'Copiar de predeterminado',
    'copy-from-default-template': 'La plantilla actual se sustituirá por los datos de la plantilla predeterminada. \r\n¿Continuar?',
    'edit-default-template': `Esto hará que la pantalla de cabecera de pozo vuelva a la plantilla predeterminada para los pozos de esta empresa. ¿Continuar?`,
    'delete-template': `Se eliminará la plantilla. ¿Continuar?`,
    'company-header-title': (companyName) => `Editar "${companyName[0]}" Plantilla de cabecera de pozo.`,
    'defaut-header-title': `Editar plantilla de cabecera de pozo predeterminada`,
    'no-template-field-error': `Seleccione al menos un campo`,
    'duplicate-template-field-error': `Tiene campos duplicados, por favor elimínelos`,

    // template
    'wells-reset-filters-help': (words) => `Al hacer clic en <b>${words[0]}</b>, se restablecerán todos los filtros, excepto las columnas seleccionadas.`,
    'wellbore-group-delete-confirm': (words) => `¿Está seguro de que desea eliminar "${words[0]}" de sus grupos de pozos?`,
    'well-has-no-users-of-role-type': (words) => `Este pozo no tiene ${words[0]}.`,
    'batch-copy-well-header-help': `
        With the following exceptions, all data (<b>including access</b>) for new wells will be copied from <b>Source Well</b>:
        <ul>
            <li>Nombre del pozo</li>
            <li>Cualquier campo especificado en el archivo CSV cargado.</li>
            <ul>
                <li>Cualquier dato contenido en el archivo CSV sustituirá a los datos copiados de <b>Pozo de origen</b>.</li>
            </ul>
        </ul>
    `,
    'batch-copy-well-footer-help': `
        <ul>
            <li>Sólo se permite un archivo.</li>
            <li>El archivo debe tener extensión .csv.</li>
            <li>Los campos obligatorios son los siguientes:
                <ul>
                    <li>Well</li>
                </ul>
            </li>
            <li>Cualquier valor que no pueda interpretarse (por ejemplo, una fecha mal formateada) o que no pueda encontrarse (por ejemplo, un nombre de activo específico o un nombre de etiqueta de pozo) se ignorará.</li>
            <li>Todas las etiquetas del pozo de origen se añadirán a los nuevos pozos y se establecerán con valores vacíos por defecto.  Puede especificar valores para las etiquetas añadiendo el nombre de la etiqueta, y los valores para cada pozo, en cualquier columna después de la columna «Plantilla».  Esa etiqueta en el nuevo pocillo se establecerá con el valor que especifique.</li>
        </ul>
    `,

};
